export default "__VITE_ASSET__e5upzFE5__"